<ion-spinner class="w-[48px] h-[48px]" color="primary" name="crescent"></ion-spinner>
